<!--
- fa机构top30
- 创建人: lzp
- 创建时间: 2019-10-12
-->
<template>
<div>
    <p class="data-tip"><i class="iconfont">&#xe654;</i>本页面榜单排行取近1年的数据，按照总服务数量多少排列。</p>
    <div class="financing_data">
        <!-- 最新Top30 投资机构Top30 -->
        <div class="list_div">
            <Table :columns="columns" :data="list"></Table>
        </div>
        <Contanct :page="3">></Contanct>
        <Spin fix v-if="spinShow">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
    </div>
</div>
</template>

<script>
import filter from 'js/filter'
import Contanct from '../Contanct'
import { faTop } from '../../../../service'
export default {
  inject: ['login'],
  components: {
    Contanct
  },
  data() {
    return {
      spinShow: true,
      list: [],
      columns: [
        { title: '排名',width: 150, align: 'center',render: (h, params) => {
          if(params.row.rank_num < 4) {
            return h('img', { attrs: {src: require('../../../../assets/pic/top'+params.row.rank_num+'.png')}})
          }else{
            return h('span', params.row.rank_num)
          }
        }},
        { title: '投资机构',width: 320, render:(h, params) => {
          return h('div',{
              class: {company: true}
            },[
            h('div',
              {
                on: {click: () => {
                  if (this.$store.state.user_key) {
                    this.goEntityDetail(params.row.uid, 1)
                  } else {
                    this.login()
                  }
                }},
                class: {logo_img: true}
              },[
                h('img', { attrs: {src: filter.logo_show(params.row.logo_path)}})
              ]),
            h('div',
              {class: {company_name: true}},[
                h('div',{class: {company_info: true}}, [
                  h('p', [
                    h('a',{
                      on: {click: () => {
                        if (this.$store.state.user_key) {
                          this.goEntityDetail(params.row.uid, 1)
                        } else {
                          this.login()
                        }
                      }}
                    }, params.row.short_name)
                  ])
                  // h('p' ,filter.empty(params.row.ht_description,'暂无描述')),
                ])
              ])
          ])
        }},
        { title: '总服务数',width: 180, render:(h, params) => {
          return h('span', params.row.event_num)
        }},
        { title: '服务案例',minWidth: 220, render:(h, params) => {
            // if (params.row.tags != '') {
            //   return h('div', {class: {'dec-clamp': true}}, filter.dealString(params.row.tags, 'dynview_tag'))
            // } else {
            //   return h('span', '--')
            // }
            if(params.row.entitys.length != 0){
              let tzf = []
              params.row.entitys.map((a,index) => {
                if(a.type != '2'){
                  tzf.push(h('a', {on: {click: () => {this.goEntityDetail(a.uid, a.type)}}}, a.short_name))
                }else{
                  tzf.push(h('span', a.short_name))
                }
                if(index < params.row.entitys.length-1) tzf.push(h('span', '、'))
              })
              return h('div', {class: {'dec-clamp': true}}, tzf)
            }else{
              return h('span','未透露')
            }
        }}
      ]
    }
  },
  methods: {
    async getList() {
      let res = await faTop({}, (error) => { this.$Message.error('请求错误！') })
      if(res.status == 'success') {
        this.list = res.res
        this.spinShow = false
      } else {
        this.$Message.error(res.message)
      }
    },
    // goEntityDetail(uid) {
    //   // this.$router.push({name:'OrgDetail',params: {uid:uid}})
    //   const { href } = this.$router.resolve({
    //     name: "OrgDetail",
    //     params: {
    //       uid: uid
    //     }
    //   })
    //   window.open(href, '_blank')
    // }
    goEntityDetail(uid, type) {
      if (this.$store.state.user_key){
        if (type == 2) {
          // this.$router.push({name: 'PeoDetail', params: {uid: uid}})
          const { href } = this.$router.resolve({
            name: "PeoDetail",
            params: {
              uid: uid
            }
          })
          window.open(href, '_blank')
        } else if(type == 1){
          // this.$router.push({name: 'OrgDetail', params: {uid: uid}})
          const { href } = this.$router.resolve({
            name: "OrgDetail",
            params: {
              uid: uid
            }
          })
          window.open(href, '_blank')
        } else if(type == 0){
          // this.$router.push({name: 'CompanyDetail', params: {uid: uid}})
          const { href } = this.$router.resolve({
            name: "CompanyDetail",
            params: {
              uid: uid
            }
          })
          window.open(href, '_blank')
        } else if(type == 3){
          // this.$router.push({name: 'HospitalDetail', params: {uid: uid}})
          const { href } = this.$router.resolve({
            name: "HospitalDetail",
            params: {
              uid: uid
            }
          })
          window.open(href, '_blank')
        }
        _czc.push(['_trackEvent', 'fa排行', 'fa排行'])
      } else {
        this.login()
      }
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/financing.stylus'
.financing_data .list_div
  padding-top: 0
  & >>> .ivu-table-wrapper
  .ivu-table
    tr
      td:first-of-type
      th:first-of-type
        .ivu-table-cell
          padding-right: 56px !important
</style>
